import { useQuery } from '@tanstack/react-query';
import { z } from 'zod';

import { BEGIN_DINER_AUTH_ENDPOINT } from 'reservations/base/constants/endpoints';
import { buildBentoboxApiEndpoint } from 'reservations/base/helpers/buildBentoboxApiEndpoint';
import { type RequestError, restClient } from 'utility/restClient';

const BeginDinerAuthResponse = z.object({
  phone_last_3: z.string(),
  has_saved_payment_methods: z.boolean().optional()
});
export type BeginDinerAuthResponse = z.infer<typeof BeginDinerAuthResponse>;

type BeginDinerAuthQueryParams = {
  dinerEmail: string;
  sendVerificationCode?: boolean;
};

export async function beginDinerAuth(
  dinerEmail: string,
  sendVerificationCode = false
) {
  const endpoint = buildBentoboxApiEndpoint(BEGIN_DINER_AUTH_ENDPOINT);

  const response = await restClient.post(endpoint, {
    data: {
      email: dinerEmail,
      send_verification_code: sendVerificationCode
    }
  });

  try {
    return BeginDinerAuthResponse.parse(response);
  } catch (err) {
    /* istanbul ignore next */
    throw err;
  }
}

export function useBeginDinerAuthQuery({
  dinerEmail,
  sendVerificationCode
}: BeginDinerAuthQueryParams) {
  return useQuery<BeginDinerAuthResponse, RequestError>({
    queryKey: ['dinerAuth', dinerEmail, sendVerificationCode],
    queryFn: () => beginDinerAuth(dinerEmail, sendVerificationCode),
    enabled: !!dinerEmail,
    retry: false
  });
}
